import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

function EditorsPick({ cateogary, PostHead, PostContent, AuthorName, date, time, image, slug }) {
    return (
        <div className="col-lg-6 col-md-6 item mt-4">
            <div className="card">
                <div className="card-header p-0 position-relative">
                    <a href={`/posts/${slug}`}>
                        <img className="card-img-bottom d-block radius-image-full" src={image} style={{ height: `15em` }} alt="Card cap" />
                    </a>
                </div>
                <div className="card-body blog-details">
                    <span className="label-blue"><a href={`/cateogary/${cateogary}`}>{cateogary.charAt(0).toUpperCase() + cateogary.slice(1)}</a></span>
                    <br />
                    <a href={`/posts/${slug}`} className="blog-desc">{PostHead}</a>
                    <p>{`${PostContent.substring(0, 150)}...`}</p>
                    <div className="author align-items-center mt-3 mb-1">
                        <img src="https://amanojha.pythonanywhere.com/media/Aman_Ojha.jpg" alt='' className="img-fluid rounded-circle" />
                        <ul className="blog-meta">
                            <li>
                                <a href="//amanojha.pythonanywhere.com/">{AuthorName}</a>
                            </li>
                            <li className="meta-item blog-lesson">
                                <span className="meta-value"> {date} </span>. <span className="meta-value ml-2"><FontAwesomeIcon icon={faClock} /> at {time}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditorsPick
